import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Session } from '../entities/session';
import { catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class VoteService {

  private baseUrl = environment.apiUrl + '/api/vote/';
  basic: string | string[];

  constructor(private http: HttpClient) { }

  getAllVoters(openId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}openspaces/${ openId }`, { responseType: 'text' });
  }
}

